'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _deep = require('helpers/deep');

var _corporate = require('constants/corporate');

var _planTypes = require('constants/plan-types');

var _video = require('constants/video');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLUB_CLASSES_NUMBERS = [0, 1];

var PlanDeriver = function () {
  function PlanDeriver() {
    (0, _classCallCheck3.default)(this, PlanDeriver);
  }

  (0, _createClass3.default)(PlanDeriver, null, [{
    key: 'nonClubPlans',
    value: function nonClubPlans(plans) {
      return plans.filter(function (plan) {
        return CLUB_CLASSES_NUMBERS.indexOf(plan.reservations_per_cycle) === -1;
      });
    }
  }, {
    key: 'augmentCurrentPlan',
    value: function augmentCurrentPlan(plan) {
      return (0, _extends3.default)({}, plan, { current: true });
    }
  }, {
    key: 'comembershipDetails',
    value: function comembershipDetails() {
      var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return {
        termsLink: (0, _deep.deepExtract)('display_metadata.additional_terms.link', plan, null),
        termsTitle: (0, _deep.deepExtract)('display_metadata.additional_terms.title', plan, null),
        banner: (0, _deep.deepExtract)('display_metadata.banner', plan, null),
        cardDetail: (0, _deep.deepExtract)('display_metadata.card_detail', plan, null)
      };
    }
  }, {
    key: 'isUpgrade',
    value: function isUpgrade(oldPlan, newPlan) {
      return oldPlan.price < newPlan.price;
    }
  }, {
    key: 'cheapestPlan',
    value: function cheapestPlan(plans) {
      return plans.reduce(function (cheapest, plan) {
        if (!cheapest || plan.price < cheapest.price) {
          return plan;
        }
        return cheapest;
      }, null);
    }
  }, {
    key: 'isComembershipPlan',
    value: function isComembershipPlan() {
      var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var type = plan.type;


      return !!type && type === _planTypes.COMEMBERSHIP;
    }
  }, {
    key: 'filterPlans',
    value: function filterPlans(plans) {
      var rules = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      if (!plans || !rules || !rules.length) {
        return plans;
      }

      return plans.filter(function (plan) {
        return rules.some(function (expr) {
          return !new RegExp(expr).test(plan.plan_code);
        });
      });
    }
  }, {
    key: 'planNeedsBillingAddress',
    value: function planNeedsBillingAddress(planName) {
      return planName !== 'ClassPass Live Beta';
    }
  }, {
    key: 'livePlanName',
    value: function livePlanName() {
      var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!plan) {
        return '';
      }

      if (plan.planMode === 'trial_no_hardware') {
        return 'trial';
      }

      return plan.planMode;
    }
  }, {
    key: 'isLiveMonthly',
    value: function isLiveMonthly() {
      var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return !!plan && !!plan.planMode && plan.planMode.substring(0, 7) === 'monthly';
    }
  }, {
    key: 'isLiveAnnual',
    value: function isLiveAnnual() {
      var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return !!plan && !!plan.planMode && plan.planMode.substring(0, 6) === 'annual';
    }
  }, {
    key: 'isLiveTrial',
    value: function isLiveTrial() {
      var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return !!plan && _planTypes.LIVE_TRIALS.indexOf(plan.planMode) > -1;
    }
  }, {
    key: 'isLiveNoHardware',
    value: function isLiveNoHardware(planMode) {
      return planMode.substr(-12) === '_no_hardware';
    }
  }, {
    key: 'sortLivePlans',
    value: function sortLivePlans(plans) {
      if (!plans) {
        return;
      }
      // Sort live plan cards by price which is in the title prefixed by a dollar sign
      plans.sort(function (a, b) {
        return parseInt(a.title.substring(1), 10) < parseInt(b.title.substring(1), 10) ? -1 : 1;
      });
      return plans;
    }
  }, {
    key: 'canToggleChromecast',
    value: function canToggleChromecast() {
      var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return plan.planMode !== _planTypes.LIVE_ANNUAL && (plan.assets || []).some(function (asset) {
        return asset.sku === _video.CHROMECAST_SKU;
      });
    }
  }, {
    key: 'isAllowPrepaidCards',
    value: function isAllowPrepaidCards() {
      var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return !!plan && _planTypes.ALLOW_PREPAID_CARDS_PLANS.indexOf(plan.plan_code) > -1;
    }
  }, {
    key: 'hasLiveHardware',
    value: function hasLiveHardware() {
      var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return !!plan && (plan.assets || []).length !== 0;
    }
  }, {
    key: 'isCorporateJustworks',
    value: function isCorporateJustworks(planCode) {
      return planCode && _corporate.CORPORATE_JUSTWORKS_REGEX.test(planCode);
    }
  }]);
  return PlanDeriver;
}();

exports.default = PlanDeriver;